import {UnpackProtocolActivityRepDto} from './UnpackProtocolActivityRepDto';
import {Dto} from '../../../../common/src/lib/dtos/dto';

export class UnpackProtocolDto extends Dto {

    activityReps: UnpackProtocolActivityRepDto [];

    public deserialize(input: any): this {
        Object.assign(this, input);
        this.activityReps = this.deserializeArray(input.activityReps, UnpackProtocolActivityRepDto);
        return this;
    }
}
